import React from "react";
import { withImageResizer } from "lib/utils";
import DateIcon from "../../Icons/DateIcon";
import Link from "next/link";
import LocationIcon from "../../Icons/LocationIcon";
import { format, isFuture } from "date-fns";
import ClockIcon from "../../Icons/ClockIcon";

const CarouselItemSmallScreen = ({
  position,
  itemData,
  isLive = false,
  upcomingEvent,
}) => {
  const createItem = ({ position, itemData }) => {
    const item = {
      styles: {},
      data: {
        ...itemData,
        upcomingEvent: "",
      },
    };
    switch (position) {
      case position - 1:
      case position + 1:
        item.styles = {
          ...item.styles,
        };
        break;
      case position:
        break;
      default:
        item.styles = { ...item.styles, ...{ display: "none" } };
        break;
    }
    item.data.upcomingEvent = isFuture(new Date(itemData?.publishingDate));
    return item;
  };
  const item = createItem({ position, itemData });

  return (
    <li>
      <Link
        href={`/?eventSlug=${item?.data?.urlName}&accountSlug=${item?.data?.account?.urlName}`}
        as={`/kirkko/${item?.data?.account?.urlName}/${item?.data?.urlName}`}
      >
        <a>
          <div
            key={item?.data?.title}
            style={item?.styles}
            className="mx-1 rounded-lg min-w-[245px]"
          >
            {isLive && (
              <div className="relative">
                <div className="absolute h-full bg-blackGradient rounded-10 max-w-full w-full h-236 flex items-center">
                  <div className="font-bold text-red right-0 top-2 absolute min-w-frontBannerSmallImg flex items-center mr-4">
                    Lähetys menossa
                    <div className="bg-red rounded-full max-w-redDot w-full h-16 ml-2"></div>
                  </div>
                </div>
              </div>
            )}
            <img
              role="img"
              alt={"Kuva" + item?.data?.title}
              className="rounded-10 bg-gray-100 max-w-[245px] w-full object-cover object-bottom h-[179px]"
              src={
                item?.data?.previewImgCDN
                  ? withImageResizer(item?.data?.previewImgCDN, 640)
                  : "/images/bg1.jpeg"
              }
            />
            <article className="rounded-br-lg rounded-bl-lg bg-white-100 flex items-center pt-1.5 pr-1 max-w-[245px]">
              <div className="flex flex-col w-full">
                <h2 className="font-bold text-left bg-white-100 truncate-text two-lines flex items-center justify-between">
                  <div
                    className={`text-bodyText origin-left  ${
                      item?.data?.upcomingEvent ? "max-w-[200px]" : ""
                    }`}
                  >
                    {item?.data?.title}
                  </div>
                </h2>
                <div className="flex justify-between">
                  <div className="flex justify-center flex-col">
                    <p className="flex items-center">
                      <LocationIcon />
                      <span className="px-2.5 pb-0.5 text-gray text-sm font-bold">
                        {item?.data?.account?.name}
                      </span>
                    </p>
                    <div className="flex justify-start flex-col">
                      <p className="flex items-center   pt-0 pl-0">
                        <span className=" text-gray text-sm font-bold">
                          {item?.data?.publishingDate && (
                            <>
                              {isLive ? (
                                <span className="flex items-center">
                                  <DateIcon />
                                  <span className="pl-2">
                                    {format(
                                      new Date(
                                        item?.data?.publishingDate
                                      ).getTime(),
                                      "dd.MM.yyyy"
                                    )}
                                  </span>
                                </span>
                              ) : (
                                <span className="flex items-center">
                                  <ClockIcon width={11.85} height={11.85} />
                                  <span className="pl-2">
                                    {format(
                                      new Date(
                                        item?.data?.publishingDate
                                      ).getTime(),
                                      "HH.mm"
                                    )}
                                  </span>
                                </span>
                              )}
                            </>
                          )}
                        </span>
                      </p>
                      <p className="flex items-center p-2.5 pt-0 pl-0 origin-left">
                        <span className="text-gray text-sm font-bold">
                          {item?.data?.publishingDate && (
                            <>
                              {isLive ? (
                                <span className="flex items-center">
                                  <ClockIcon width={11.85} height={11.85} />
                                  <span className="pl-2">
                                    Alkanut:{" "}
                                    {format(
                                      new Date(
                                        item?.data?.publishingDate
                                      ).getTime(),
                                      "HH.mm"
                                    )}
                                  </span>
                                </span>
                              ) : (
                                <span className="flex items-center">
                                  <DateIcon />
                                  <span className="pl-2">
                                    {" "}
                                    {format(
                                      new Date(
                                        item?.data?.publishingDate
                                      ).getTime(),
                                      "dd.MM.yyyy"
                                    )}
                                  </span>
                                </span>
                              )}
                            </>
                          )}
                        </span>
                      </p>
                    </div>
                  </div>
                </div>
              </div>
              {isLive && <></>}
            </article>
          </div>
        </a>
      </Link>
    </li>
  );
};
export default CarouselItemSmallScreen;
